<script setup lang="ts">
import { ref } from 'vue';
import { RBtn } from '@therobotcompany/robco-frontend-library';
import type { VisionProject } from '@/models/RobVision';
import { deleteProject } from '@/api/RobVisionApi';

const props = defineProps<{ isOpen: boolean; project: VisionProject | null }>();
const emit = defineEmits(['update:isOpen', 'project-archived']);

// The backend call is a soft delete: the project is flagged as deleted and
// hidden for all members, while its data is kept.
const archiveError = ref('');

const cancel = () => {
  emit('update:isOpen', false);
  archiveError.value = '';
};

const confirm = async () => {
  if (!props.project) {
    return;
  }
  try {
    await deleteProject(props.project.uuid);
    emit('project-archived');
    cancel();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error('Failed to archive project:', error);
    archiveError.value = error.message;
  }
};
</script>

<template>
  <v-dialog :model-value="isOpen" max-width="600" @click:outside="cancel">
    <v-card>
      <v-card-title>{{ $gettext('Archive Project') }}</v-card-title>
      <v-card-text>
        <p>
          {{ $gettext('Are you sure you want to archive this project?') }}
        </p>
        <p>
          <b>{{ project?.name }}</b>
        </p>
      </v-card-text>
      <v-alert v-if="archiveError" class="mx-2" type="error">{{
        archiveError
      }}</v-alert>
      <v-card-actions>
        <r-btn variant="outlined" @click="cancel">
          {{ $gettext('Close') }}
        </r-btn>
        <v-spacer></v-spacer>
        <r-btn variant="accent" icon="mdi-archive-outline" @click="confirm">
          {{ $gettext('Archive') }}
        </r-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
